import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';

export default function SignUpButton({ title, onPress }) {
  return (
    <TouchableOpacity style={styles.button} onPress={onPress}>
      <Text style={styles.buttonText}>{title}</Text>
    </TouchableOpacity>
  );
}

const styles = EStyleSheet.create({
  button: {
    marginVertical: '.7rem',
    borderRadius: 90, 
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
    width: '20rem',
    backgroundColor: '$forwardButtonBackgroundColor'
  },
  buttonText: {
    color: '$buttonTextColor',
    fontSize: '1rem',
    fontWeight: '600',
    textTransform: 'uppercase'
  }
});